type InfosType = {
	displaySocials?: boolean;
	displayMail?: boolean;
	displayPhone?: boolean;
	socials?: string[];
	emailInfos: any;
	phoneInfos: any;
};

export default function InfosCard(props: InfosType) {
	const { displaySocials, displayMail, displayPhone, socials, emailInfos, phoneInfos } = props;

	return (
		<>
			{displaySocials && socials && socials?.length > 0 && (
				<>
					{socials.map((social: any, i: number) => (
						<a
							key={i}
							href={social.url}
							className='text-minos-teams-social-color'
							target='_blank'
							rel='noreferrer'
						>
							{social.icon && <i className={social.icon}></i>}
						</a>
					))}
				</>
			)}
			{displayMail && emailInfos && emailInfos.email && (
				<a
					href={'mailto:' + emailInfos.email}
					className='text-minos-teams-social-color'
					target='_blank'
					rel='noreferrer'
				>
					{emailInfos.icon && <i className={emailInfos.icon}></i>}
				</a>
			)}
			{displayPhone && phoneInfos && phoneInfos.phone && (
				<a
					href={'tel:' + phoneInfos.phone}
					className='text-minos-teams-social-color'
					target='_blank'
					rel='noreferrer'
				>
					{phoneInfos.icon && <i className={phoneInfos.icon}></i>}
				</a>
			)}
		</>
	);
}
